import { render, staticRenderFns } from "./ApplicationDetails.vue?vue&type=template&id=6f45b718&scoped=true"
import script from "./ApplicationDetails.vue?vue&type=script&lang=js"
export * from "./ApplicationDetails.vue?vue&type=script&lang=js"
import style0 from "./ApplicationDetails.vue?vue&type=style&index=0&id=6f45b718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f45b718",
  null
  
)

export default component.exports